import NumberSeparators from 'utils/personalizer/NumberSeparators';

var NumberParser = function(options = {}) {
    this.numberSeparator = options.numberSeparator;
    if (!this.numberSeparator) {
        throw new Error('NumberParser - must specify a separator');
    }
};

NumberParser.prototype.parse = function(numberString) {
    if (typeof numberString !== 'string') {
        throw new Error('NumberParser - invalid input');
    }

    if (this.numberSeparator === NumberSeparators.DECIMAL_PERIOD) {
        var dec = '.',
            group = ',';
    } else if (this.numberSeparator === NumberSeparators.DECIMAL_COMMA) {
        var dec = ',',
            group = '.';
    } else {
        throw new Error('Unsupported number format');
    }

    var valid = '1234567890.-';

    while (numberString.indexOf(group) > -1) {
        numberString = numberString.replace(group, '');
    }
    numberString = numberString.replace(dec, '.');

    var validText = '';
    var hasPercent = false;
    if (numberString.charAt(numberString.length - 1) == '%') {
        hasPercent = true;
    }

    for (var i = 0; i < numberString.length; i++) {
        if (valid.indexOf(numberString.charAt(i)) > -1) validText = validText + numberString.charAt(i);
    }

    if (validText === '') {
        throw new Error('NumberParser - invalid number');
    }

    // parseFloat would be a more logical choice here, but it parses slightly differently
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseFloat
    // "parseFloat() is more lenient than Number() because it ignores trailing invalid characters, which would cause Number() to return NaN."

    var number = +new Number(validText);
    if (hasPercent) {
        var decimalPos = validText.indexOf(dec);
        if (decimalPos != -1) {
            var decimalPoints = validText.length - decimalPos - 1;
            number = +new Number(number.toFixed(decimalPoints + 2));
        } else {
            number = +new Number(number.toFixed(validText.length));
        }
        number = number / 100;
    }

    return number;
};

export default NumberParser;
